import { Badge } from '@evogard/ui';
import {
  CLAIM_CLOSURE_KIND_LABELS,
  claimClosureKindOf,
  peripheralPhaseLabel,
  type ClaimClosureKind,
  type ClaimClosureOrigin,
  type Tone,
} from '@evogard/domain';
import { DEPARTMENT_LABEL, phaseLabel } from '../claim/labels.js';

/**
 * O vocabulário dos Encerrados (13/10/2026) fora da tela deles: a lista de
 * Sinistros, a ficha e as mesas dizem que o sinistro encerrou com as MESMAS
 * palavras e o mesmo selo da lista de Encerrados.
 */

/** De onde o encerrado saiu, como o menu chama. */
// @valor — as chaves são os valores de `ClaimClosureOrigin`
export const CLOSURE_ORIGIN_LABEL: Readonly<Record<ClaimClosureOrigin, string>> = {
  ...DEPARTMENT_LABEL,
  perifericos: 'Periféricos',
};

/**
 * O desfecho é estado, e leva o selo de estado. Toda conclusão é o trabalho
 * feito — o nome diz qual (22/10/2026). A desistência é neutra: não é nem o
 * trabalho feito nem a recusa da casa — é o cliente que saiu.
 */
// @valor — as chaves são os valores de `ClaimClosureKind`
export const CLOSURE_KIND_TONE: Readonly<Record<ClaimClosureKind, Tone>> = {
  concluido_reparo: 'sucesso',
  concluido_indenizacao: 'sucesso',
  concluido_periferico: 'sucesso',
  concluido_somente_terceiro: 'sucesso',
  desistencia: 'neutro',
  negado: 'erro',
};

/** O nome da fase de desfecho, ou da fase de onde ele saiu, na origem. */
export function closurePhaseLabel(origin: ClaimClosureOrigin, phase: string): string {
  return origin === 'perifericos'
    ? peripheralPhaseLabel(phase)
    : phaseLabel(origin, phase);
}

/**
 * "Encerrado · Negativa" quando a fase encerra, e nada quando não encerra. A
 * fase exata ("Negados com Posse") vai na dica: o selo diz o desfecho.
 */
export function ClosureBadge({
  origin,
  phase,
}: {
  origin: ClaimClosureOrigin;
  phase: string;
}) {
  const kind = claimClosureKindOf(origin, phase);
  if (!kind) return null;
  return (
    <span title={closurePhaseLabel(origin, phase)}>
      <Badge tone={CLOSURE_KIND_TONE[kind]}>
        Encerrado · {CLAIM_CLOSURE_KIND_LABELS[kind]}
      </Badge>
    </span>
  );
}
